export default __webpack_public_path__ + "static/review_image-98f3922bc5846889ff22471a3961e117.webp";